import { IonContent, IonModal } from '@ionic/react';
import { type ComponentProps, type PropsWithChildren, type Ref } from 'react';

import styles from './BackModal.module.css';

import { Button } from '../Button';
import { ModalFooter } from '../ModalFooter/ModalFooter';
import { ModalHeader } from '../ModalHeader/ModalHeader';

interface ModalProps extends ComponentProps<typeof IonModal> {
  ref?: Ref<HTMLIonModalElement>;
  handleClose: VoidFunction;
  onConfirm: VoidFunction;
}

export const BackModal = ({ onConfirm, handleClose, ref, ...props }: PropsWithChildren<ModalProps>) => {
  return (
    <IonModal className={styles.modal} {...props} onDidDismiss={handleClose} ref={ref}>
      <ModalHeader>End session?</ModalHeader>
      <IonContent className={styles.content}>
        <div className={styles.inner}>
          <p className={styles.text}>
            Are you sure you want to go back? <br />
            Going back will <strong>reset your current session and disconnect all sensors</strong>.
          </p>
        </div>
      </IonContent>
      <ModalFooter>
        <Button className={styles.button} onClick={handleClose} size='small' variant='secondary'>
          Cancel
        </Button>
        <Button className={styles.button} onClick={onConfirm} size='small' variant='danger'>
          End session
        </Button>
      </ModalFooter>
    </IonModal>
  );
};
